import { type ComponentProps, forwardRef } from "react";

import { twMerge } from "tailwind-merge";

interface Props extends ComponentProps<"div"> {
  className?: string;
}

export const Dropdown = forwardRef<HTMLDivElement, Props>(
  ({ className, children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={twMerge(
          "z-[9999] bg-v2-primary w-[var(--button-width)] border border-v2-tertiary rounded-md text-v2-primary",
          "elevation-1 origin-top transition duration-200 ease-out p-[1px]",
          "max-h-[260px] data-[closed]:translate-y-1 data-[closed]:opacity-0",
          className,
        )}
        {...props}
      >
        {children}
      </div>
    );
  },
);
